import { configureStore } from '@reduxjs/toolkit'
import TabReducer from './reducers/tab'
import permissionSlice from './reducers/permissionSlice'
import userSlice from './reducers/userSlice'

export default configureStore({
  reducer: {
    tab: TabReducer,
    permission: permissionSlice.reducer,
    user: userSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      //关闭redux序列化检测
      serializableCheck: false
    })
})
